import { put, call, delay } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as TypesInformation } from '../../getProcedureInformation/actions';
import { Types as TypesRegister } from '../actions';
import { Types as TypesStatus } from '../../getStudentProcedureStatus/actions';
import { Types as TypesProceduresByStudent } from '../../getProceduresByStudent/actions';
import RegisterCarnetRequestRepository from '../../../../repositories/ProceduresRepository';
import RegisterCarnetRequestDataRepository from '../../../../../data/repositories/ProceduresDataRepository';
import config from '../../../../../core/config/config';

export default function* execute(action: any): any {
  try {
    yield put({ type: Types.CANCEL_REGISTER_CARNET_REQUEST });
    const registerCarnetRequestRepository: RegisterCarnetRequestRepository =
      new RegisterCarnetRequestDataRepository();
    const registerCarnetCancelResponse = yield call(
      registerCarnetRequestRepository.cancelRegisterCarnet,
      action.requestId,
      action.procedureId
    );
    if (config.DATASOURCE_ENV === 'MOCK') yield delay(1000);
    if (!registerCarnetCancelResponse) {
      yield put({
        type: Types.CANCEL_REGISTER_CARNET_FAILURE,
        error: 'No se pudo cancelar'
      });
      return;
    }

    if (registerCarnetCancelResponse?.error) {
      yield put({
        type: Types.CANCEL_REGISTER_CARNET_FAILURE,
        requestId: registerCarnetCancelResponse?.requestId,
        procedureId: registerCarnetCancelResponse?.procedureId,
        error:
          registerCarnetCancelResponse?.error ||
          'Ocurrió un error al momento de cancelar la solicitud.'
      });
      return;
    }
    yield put({
      type: TypesProceduresByStudent.GET_PROCEDURES_BY_STUDENT_CLEAR
    });
    yield put({
      type: TypesRegister.REGISTER_CARNET_CLEAR
    });
    // clear OKs
    yield put({
      type: TypesInformation.GET_PROCEDURE_INFORMATION_CLEAR
    });
    yield put({
      type: TypesStatus.GET_STUDENT_PROCEDURE_STATUS_CLEAR
    });
    yield put({
      type: Types.CANCEL_REGISTER_CARNET_SUCCESS,
      requestId: registerCarnetCancelResponse?.requestId,
      procedureId: registerCarnetCancelResponse?.procedureId
    });
  } catch (error) {
    yield put({
      type: Types.CANCEL_REGISTER_CARNET_FAILURE,
      error: 'Ocurrió un error al momento de cancelar la solicitud.'
    });
  }
}
